<template>
    <header>
        <div class="wrapper">
                <img src="assets/images/logo_small.png" />
                <a href="https://apps.apple.com/us/app/társkereső/id1490994095" target="_blank" class="store-badge small">
                    <img src="assets/images/appstore_white.svg">
                </a>
        </div>
        <div class="menu">
            <router-link to="/">Társkereső</router-link>
            <router-link to="/felhasznalasi-feltetelek">Felhasználási feltételek</router-link>
        </div>
    </header>
</template>